<div class="row" *ngIf="!isEnrolmentEdit">
  <div class="col-sm-12">
    <div class="content-header">Enrollment Form</div>
  </div>
</div>
<section id="ngx" *ngIf="!isEnrolmentEdit">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
        <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
          <aw-wizard-step [stepTitle]="'Step 1'" [navigationSymbol]="{
              symbol: '&#xf007;',
              fontFamily: 'FontAwesome'
            }">
            <form #studentForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Student Information</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="name">Name</label>
                        <fieldset class="position-relative has-icon-right">
                          <input class="form-control input-md" [(ngModel)]="enrolmentModel.name" ngModel #name="ngModel"
                            required readonly id="name" name="name" type="text" />
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mt-3">
                      <div class="form-group">
                        <!-- <label class="form-control-label mb-1" for="college"
                          >College
                          <div
                            *ngIf="selectedCollege"
                            class="custom-switch custom-control-inline mb-1 mb-xl-0"
                          >
                            <input
                              type="checkbox"
                              (change)="
                                updateBusiness(
                                  selectedCollege,
                                  checkIfCollegeActivated(selectedCollege)
                                    ? false
                                    : true
                                )
                              "
                              class="custom-control-input cursor"
                              id="custom-switch-1"
                              [checked]="
                                checkIfCollegeActivated(selectedCollege)
                              "
                            />
                            <label
                              class="custom-control-label mr-1"
                              for="custom-switch-1"
                            >
                              <span>{{
                                checkIfCollegeActivated(selectedCollege)
                                  ? "Activated"
                                  : "Deactivated"
                              }}</span>
                            </label>
                          </div>
                        </label> -->
                        <fieldset class="position-relative has-icon-right">
                          <ng-select [items]="collegeList" bindLabel="name" bindValue="_id" placeholder="Select College"
                            [(ngModel)]="selectedCollege" [ngModelOptions]="{ standalone: true }"
                            (change)="getCollegeId($event)" #college="ngModel">
                            <ng-template ng-header-tmp>
                              <div>
                                <button class="btn btn-link" (click)="goToPage()">
                                  <!-- (click)="openContent(1)" -->

                                  Add New College
                                </button>
                              </div>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item">
                              <img height="15" width="15" [src]="item.avatar" />
                              <span [style.color]="
                                  !item.is_activated ? 'red' : 'black'
                                ">{{ item.name }}</span>
                            </ng-template>
                          </ng-select>
                          <div *ngIf="selectedCollege" class="form-control-position">
                            <a [href]="'business/edit/' + selectedCollege" target="_blank"><i
                                class="cursor ft-edit"></i></a>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="email">Email</label>
                        <fieldset class="position-relative has-icon-right">
                          <input class="form-control input-md" [(ngModel)]="enrolmentModel.email" ngModel
                            #email="ngModel" required email id="email" name="email" type="text" readonly />
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="phone">Phone Number</label>
                        <fieldset class="position-relative has-icon-right">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">+91</span>
                            </div>
                            <input class="form-control input-md" [(ngModel)]="enrolmentModel.phone" #phone="ngModel"
                              required id="phone" name="phone" type="text"placeholder="e.g. 1234-567-890"
                              mask="0000-000-000" minlength="10" readonly />
                          </div>
                          <div class="form-control-position">
                            <a [href]="
                                'student-edit/' + enrolmentModel.user_id._id
                              " target="_blank"><i class="cursor ft-edit"></i></a>
                          </div>
                        </fieldset>
                      </div>
                    </div>
                    <!-- <div class='col-12 col-sm-6'>
                                            <div class="form-group">
                                                <label class="form-control-label" for="last_qualification">Last Qualification</label>
                                                <input class="form-control input-md" [(ngModel)]="enrolmentModel.last_qualification" ngModel #last_qualification="ngModel" required id="last_qualification" name="last_qualification" type="text">
                                                <small class="form-text text-muted danger" *ngIf="!last_qualification.valid && (last_qualification.dirty || last_qualification.touched)">last_qualification number is required!</small>
                                            </div>
                                        </div> -->
                  </div>

                  <div class="form-group text-center">
                    <button type="button" uiSref="work" class="btn btn-info" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 2'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #learningForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Learning Interest</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="categoryInterest">Category Interest</label>
                        <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Course Category Interest" [(ngModel)]="selectedCategory"
                          [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)"
                          #courseCategory="ngModel">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="skills">Skills</label>
                        <ng-select [items]="skillList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                          [closeOnSelect]="false" placeholder="Select Skills" [(ngModel)]="skillTags"
                          [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                    </div>
                    <!-- <div class='col-12 col-sm-6'>
                                            <div class="form-group">
                                                <label class="form-control-label" for="number">Phone Number</label>
                                                <input class="form-control input-md" ngModel #number="ngModel" required id="number" name="number" type="text">
                                                <small class="form-text text-muted danger" *ngIf="!number.valid && (number.dirty || number.touched)">This field is required!</small>
                                            </div>
                                        </div> -->
                  </div>

                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button type="button" uiSref="work" class="btn btn-info" [disabled]="!learningForm.valid"
                      awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                  <!-- <div class="form-group text-center">
                                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                                        <span style="margin-right:10px;">
                                            <i class="ft-chevron-left"></i>
                                        </span> Previous</button>
                                    <button uiSref="result" type="button" class="btn btn-success" [disabled]="!personalForm.valid" awResetWizard>
                                        Finish
                                        <span style="margin-left:10px;">
                                            <i class="ft-chevron-right"></i>
                                        </span>
                                    </button>
                                </div>
   -->
                  <!-- <div class="form-group text-center">
                                        <button type="button" uiSref="work" class="btn btn-info" [disabled]="!personalForm.valid" awNextStep>
                                            Next
                                            <span style="margin-left:10px;">
                                                <i class="ft-chevron-right"></i>
                                            </span>
                                        </button>
                                    </div> -->
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 3'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #internalForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Internal Records</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="huntingBy">Hunting by</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Hunting By"
                          [(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }"
                          (change)="getHuntId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="farmingBy">Farming by</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Farming By"
                          [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }"
                          (change)="getFarmId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="goal">Goal</label>
                        <ng-select [items]="goalList" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Goal" [(ngModel)]="goal" [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label>Learning Mode</label>
                        <ng-select [items]="learningList" bindLabel="displayname" bindValue="_id"
                          placeholder=" Select Mode" [(ngModel)]="selectLearningMode"
                          [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="team">Team</label>
                        <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Team" [(ngModel)]="team" [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Agency<span class="required_field">*</span></label>
                        <ng-select [items]="agency_List" bindLabel="name" bindValue="_id" [closeOnSelect]="false"
                          placeholder="Select Agency" [(ngModel)]="agency" [ngModelOptions]="{ standalone: true }" (change)="getAgencyId($event)">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                     
                      <div class="form-group">
                        <label>Next Action</label>
                        <ng-select [items]="nextactionList" bindLabel="displayname" bindValue="_id"       placeholder="Select next action"
                          [(ngModel)]="enrolmentModel.next_action" [ngModelOptions]="{standalone: true}" (change)="getChangeNextAction($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label>Last Response</label>
                        <input type="text" class="form-control" [(ngModel)]="enrolmentModel.lastresponse" [ngModelOptions]="{standalone: true}" placeholder="Enter Last Response" >
                      </div>
                      <div class="form-group">
                        <label>Last Active Date</label>
                        <input type="date" class="form-control" [(ngModel)]="enrolmentModel.last_activedate" [ngModelOptions]="{standalone: true}" placeholder="Enter Date" >
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="notes">Documents & Incentives</label>
                        <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.notes" ngModel
                          #notes="ngModel" name="notes" id="notes" cols="30" rows="5"></textarea>
                        <small class="form-text text-muted danger"
                          *ngIf="!notes.valid && (notes.dirty || notes.touched)">notes is required!</small>
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button type="button" uiSref="work" class="btn btn-info" [disabled]="!internalForm.valid"
                      awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 4'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #enrollmentForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Enrolment</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="course">Course</label>
                        <ng-select [items]="courseList" bindLabel="title" bindValue="_id" placeholder="Select Course"
                          [(ngModel)]="selectedCourse" ngModel #course="ngModel" required name="course"
                          [ngModelOptions]="{ standalone: true }" required course id="course"
                          (change)="getCourseId($event)" #Course>
                                <ng-template ng-option-tmp let-item="item">
    <span>{{item.title+' | '+item?.duration?.displayname}}</span>
  </ng-template>
                        </ng-select>
                        <small class="form-text text-muted danger" *ngIf="
                            !course.valid && (course.dirty || course.touched)
                          ">course is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Mentor</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id"
                          placeholder="Select Mentor" [(ngModel)]="selected_mentor" [ngModelOptions]="{ standalone: true }"
                          (change)="getMentorId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">Buddy</label>
                        <ng-select [items]="usersList" bindLabel="name" bindValue="_id"
                          placeholder="Select Buddy" [(ngModel)]="selected_buddy" [ngModelOptions]="{ standalone: true }"
                          (change)="getBuddyId($event)">
                        </ng-select>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="batch">Batch</label>
                        <ng-select [items]="batchList" bindLabel="name" bindValue="_id"
                          placeholder="Select Batch" [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }"
                          (change)="getBatchId($event)">
                          <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-link" (click)="openContent(2)">
                                Add New Batch
                              </button>
                            </div>
                          </ng-template> -->
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="batch">Batch Schedule</label>
                        <ng-select [items]="batchSchedule_list" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Batch Schedule" [(ngModel)]="selectedBatch_schedule" [ngModelOptions]="{ standalone: true }"
                          (change)="getBatchScheduleId($event)">
                          <!-- <ng-template ng-header-tmp>
                            <div>
                              <button class="btn btn-link" (click)="openContent(2)">
                                Add New Batch
                              </button>
                            </div>
                          </ng-template> -->
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="course">Date Of Joining</label>
                        <input type="date" name="enrolmentModel.date_of_joining" class="form-control input-md" [(ngModel)]="enrolmentModel.date_of_joining"
                          [ngModel]="enrolmentModel.date_of_joining | date: 'yyyy-MM-dd'" [disabled]="false">
                      </div>
                      
                      <!-- <div class="form-group">
                        <label>Checklist</label>
                        <ng-select
                        [items]="list_type"
                        bindLabel="name"
                        bindValue="_id"
                        [closeOnSelect]="false"
                        placeholder="Select Checklist"
                        [(ngModel)]="selected_check_list"
                        [ngModelOptions]="{ standalone: true }"
                        (change)="getCheckListId($event)"
                      ></ng-select>
                      </div> -->
                    </div>
                    
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button [disabled]="!course.valid" type="button" uiSref="work" class="btn btn-info" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 5'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #feesForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Fees</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="total_fees">Total Fees</label>
                        <input type="text" class="form-control input-md" [(ngModel)]="enrolmentModel.total_fees" ngModel
                          #total_fees="ngModel" name="total_fees" id="total_fees" readonly />
                        <small class="form-text text-muted danger" *ngIf="
                            !total_fees.valid &&
                            (total_fees.dirty || total_fees.touched)
                          ">Total Fees is required!</small>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="net_fees">Net Fees</label>
                        <input type="text" class="form-control input-md" [(ngModel)]="enrolmentModel.net_fees" ngModel
                          #net_fees="ngModel" name="net_fees" id="net_fees"/>
                        <small class="form-text text-muted danger" *ngIf="
                            !net_fees.valid &&
                            (net_fees.dirty || net_fees.touched)
                          ">net fees is required!</small>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="discount">Discount</label>
                        <ng-select [items]="discountList" bindLabel="name" bindValue="_id" [multiple]="true"
                          placeholder="Select Discount" [(ngModel)]="selectedDiscount"
                          [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="discount_amounts">Paying Amount</label>
                        <input type="number" class="form-control input-md" [(ngModel)]="paid_amount" ngModel
                          #payable_amount="ngModel" name="payable_amount" />
                        <small class="form-text text-muted danger" *ngIf="
                            !payable_amount.valid &&
                            (payable_amount.dirty || payable_amount.touched)
                          ">payable amount is required!</small>
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button type="button" uiSref="work" class="btn btn-info" [disabled]="!feesForm.valid" awNextStep>
                      Next
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
          <aw-wizard-step [stepTitle]="'Step 6'" [navigationSymbol]="{
              symbol: '&#xf0b1;',
              fontFamily: 'FontAwesome'
            }">
            <form #registrationForm="ngForm" class="editForm" novalidate>
              <h4 class="head text-center mt-2">Registration</h4>
              <br />
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="notes">Payment Description</label>
                        <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.admin_notes" ngModel
                          #admin_notes="ngModel" name="admin_notes" id="admin_notes" cols="30" rows="8"></textarea>
                        <!-- <small
                          class="form-text text-muted danger"
                          *ngIf="!admin_notes.valid && (admin_notes.dirty || admin_notes.touched)"
                          >adminnotes is required!</small -->
                      </div>
                    </div>
                    <div class="col-12 col-sm-6">
                      <div class="form-group">
                        <label class="form-control-label" for="status">Payment Status</label>
                        <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name"
                          placeholder="Select Status" [(ngModel)]="selectedPaymentStatus"
                          [ngModelOptions]="{ standalone: true }">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label" for="status">Payment Mode</label>
                        <ng-select [items]="paymentMode" bindLabel="displayname" bindValue="_id"
                          placeholder="Select Payment Mode" [(ngModel)]="selectedPaymentMode"
                          [ngModelOptions]="{ standalone: true }" (change)="getPaymentModeId($event)">
                        </ng-select>
                      </div>
                      <div class="form-group">
                        <label for="next_payment_date">Next payment date</label>
                        <input type="date" class="form-control" [(ngModel)]="enrolmentModel.next_payment_date" ngModel
                          #next_payment_date="ngModel" min="{{ min_next_payment_date }}" name="next_payment_date"
                          id="next_payment_date" />
                      </div>
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button uiSref="work" type="button" class="btn btn-secondary mr-1" awPreviousStep>
                      <span style="margin-right: 10px">
                        <i class="ft-chevron-left"></i>
                      </span>
                      Previous
                    </button>
                    <button uiSref="result" (click)="submit()" type="button" class="btn btn-success" awResetWizard>
                      Finish
                      <span style="margin-left: 10px">
                        <i class="ft-chevron-right"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </aw-wizard-step>
        </aw-wizard>
      </div>
    </div>
  </div>
</section>
<!--------------------------------------------------------------------------------------------------------- -->
<section class="users-edit" *ngIf="isEnrolmentEdit">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- Nav-tabs -->
            <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav-tabs justify-content-left">
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link d-flex align-items-center">
                  <i class="ft-user mr-1"></i>
                  <span class="d-none d-sm-block">Account</span>
                </a>
                <ng-template ngbNavContent>
                  <!-- Account content starts -->
                  <div class="mt-2" id="account">
                    <!-- Media object starts -->
                    <div class="media">
                      <div *ngIf="!enrolmentModel?.image" [class.initial-alpha]="!enrolmentModel?.image"
                        class="users-avatar-shadow mr-1 ml-0 bg-primary">
                        <div class="avatar-content">
                          {{ enrolmentModel?.name | titlecase | shortName }}
                        </div>
                      </div>
                      <div class="media-body mt-3">
                        <h4>{{enrolmentModel?.name | titlecase}}</h4>
                        <!-- <div class="d-flex flex-sm-row flex-column justify-content-start px-0 mb-sm-2">
                          <button class="btn btn-sm btn-primary mb-1 mb-sm-0">Change</button>
                          <button class="btn btn-sm bg-light-secondary ml-sm-2">Reset</button>
                        </div> -->
                      </div>
                    </div>
                    <!-- Media object ends -->

                    <!-- Account form starts -->
                    <form novalidate>
                      <div class="row">
                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label class="form-control-label" for="name">Name</label>
                            <fieldset class="position-relative has-icon-right">
                              <input class="form-control input-md" [(ngModel)]="enrolmentModel.name" ngModel
                                #name="ngModel" required readonly id="name" name="name" type="text" />
                              <div class="form-control-position">
                                <a [href]="
                                    'student-edit/' + enrolmentModel.user_id._id
                                  " target="_blank"><i class="cursor ft-edit"></i></a>
                              </div>
                            </fieldset>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="email">Email</label>
                            <fieldset class="position-relative has-icon-right">
                              <input class="form-control input-md" [(ngModel)]="enrolmentModel.email" ngModel
                                #email="ngModel" required email id="email" name="email" type="text" readonly />
                              <div class="form-control-position">
                                <a [href]="
                                    'student-edit/' + enrolmentModel.user_id._id
                                  " target="_blank"><i class="cursor ft-edit"></i></a>
                              </div>
                            </fieldset>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="phone">Phone Number</label>
                            <fieldset class="position-relative has-icon-right">
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" id="basic-addon1">+91</span>
                                </div>
                                <input class="form-control input-md" [(ngModel)]="enrolmentModel.phone" #phone="ngModel"
                                  required id="phone" name="phone" type="text" placeholder="e.g. 1234-567-890"
                                  mask="0000-000-000" minlength="10" readonly />
                              </div>
                              <div class="form-control-position">
                                <a [href]="
                                    'student-edit/' + enrolmentModel.user_id._id
                                  " target="_blank"><i class="cursor ft-edit"></i></a>
                              </div>
                            </fieldset>
                          </div>
                          <div class="form-group">

                            <label class="form-control-label" for="name">College</label>
                            <fieldset class="position-relative has-icon-right">
                              <ng-select [items]="collegeList" bindLabel="name" bindValue="_id" placeholder="Select College"
                                [(ngModel)]="selectedCollege" [ngModelOptions]="{ standalone: true }"
                                (change)="getCollegeId($event)" #college="ngModel">
                                <ng-template ng-label-tmp let-item="item">
                                  <img height="15" width="15" [src]="item.avatar" />
                                  <span [style.color]="
                                      !item.is_activated ? 'red' : 'black'
                                    ">{{ item.name }}</span>
                                </ng-template>
                              </ng-select>
                              <!-- <div *ngIf="selectedCollege" class="form-control-position">
                                <a [href]="'business/edit/' + selectedCollege" target="_blank"><i
                                    class="cursor ft-edit"></i></a>
                              </div> -->
                            </fieldset>

                            <!-- <label class="form-control-label mb-1" for="college"
                              >College
                              <div
                                *ngIf="selectedCollege"
                                class="custom-switch custom-control-inline mb-1 mb-xl-0"
                              >
                                <input
                                  type="checkbox"
                                  (change)="
                                    updateBusiness(
                                      selectedCollege,
                                      checkIfCollegeActivated(selectedCollege)
                                        ? false
                                        : true
                                    )
                                  "
                                  class="custom-control-input cursor"
                                  id="custom-switch-1"
                                  [checked]="
                                    checkIfCollegeActivated(selectedCollege)
                                  "
                                />
                                <label
                                  class="custom-control-label mr-1"
                                  for="custom-switch-1"
                                >
                                  <span>{{
                                    checkIfCollegeActivated(selectedCollege)
                                      ? "Activated"
                                      : "Deactivated"
                                  }}</span>
                                </label>
                              </div>
                            </label> -->
                            <!-- <fieldset class="position-relative has-icon-right">
                              <ng-select
                                [items]="collegeList"
                                bindLabel="name"
                                bindValue="_id"
                                placeholder="Select College"
                                [(ngModel)]="selectedCollege"
                                [ngModelOptions]="{ standalone: true }"
                                (change)="getCollegeId($event)"
                                #college="ngModel"
                              >
                                <ng-template ng-header-tmp>
                                  <div>
                                    <button
                                      class="btn btn-link"
                                      (click)="goToPage()"
                                    >
                                    
    
                                      Add New College
                                    </button>
                                  </div>
                                </ng-template>
                                <ng-template ng-label-tmp let-item="item">
                                  <img height="15" width="15" [src]="item.avatar" />
                                  <span
                                    [style.color]="
                                      !item.is_activated ? 'red' : 'black'
                                    "
                                    >{{ item.name }}</span
                                  >
                                </ng-template>
                              </ng-select>
                              <div
                                *ngIf="selectedCollege"
                                class="form-control-position"
                              >
                                <a
                                  [href]="'business/edit/' + selectedCollege"
                                  target="_blank"
                                  ><i class="cursor ft-edit"></i
                                ></a>
                              </div>
                            </fieldset> -->
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="categoryInterest">Category Interest</label>
                            <ng-select [items]="categoryList" bindLabel="displayname" bindValue="_id"
                              placeholder="Select Course Category Interest" [(ngModel)]="selectedCategory"
                              [ngModelOptions]="{ standalone: true }" (change)="getCategoryId($event)"
                              #courseCategory="ngModel">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="skills">Skills</label>
                            <ng-select [items]="skillList" bindLabel="displayname" bindValue="_id" [multiple]="true"
                              [closeOnSelect]="false" placeholder="Select Skills" [(ngModel)]="skillTags"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="huntingBy">Hunting by</label>
                            <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Hunting By"
                              [(ngModel)]="selectedHuntingBy" [ngModelOptions]="{ standalone: true }"
                              (change)="getHuntId($event)">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="farmingBy">Farming by</label>
                            <ng-select [items]="usersList" bindLabel="name" bindValue="_id" placeholder="Farming By"
                              [(ngModel)]="selectedFarmingBy" [ngModelOptions]="{ standalone: true }"
                              (change)="getFarmId($event)">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="goal">Goal</label>
                            <ng-select [items]="goalList" bindLabel="displayname" bindValue="_id"
                              [closeOnSelect]="false" placeholder="Select Goal" [(ngModel)]="goal"
                              [ngModelOptions]="{ standalone: true }" (change)="getGoalId($event)">
                            </ng-select>
                          </div>
                          
                          <div class="form-group">
                            <label>Learning Mode</label>
                            <ng-select [items]="learningList" bindLabel="displayname" bindValue="_id"
                              placeholder=" Select Mode" [(ngModel)]="selectLearningMode"
                              [ngModelOptions]="{ standalone: true }" (change)="getModeId($event)">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="team">Team</label>
                            <ng-select [items]="teamList" bindLabel="displayname" bindValue="_id"
                              [closeOnSelect]="false" placeholder="Select Team" [(ngModel)]="team"
                              [ngModelOptions]="{ standalone: true }" (change)="getTeamId($event)">
                            </ng-select>
                          </div>
                        

                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group">
                            <label class="form-control-label" for="course">Course</label>
                            <ng-select [items]="courseList" bindLabel="title" bindValue="_id"
                              placeholder="Select Course" [(ngModel)]="selectedCourse" ngModel #course="ngModel"
                              required name="course" [ngModelOptions]="{ standalone: true }" required course id="course"
                              (change)="getCourseId($event)" #Course>
                                <ng-template ng-option-tmp let-item="item">
    <span>{{item.title+' | '+item?.duration?.displayname}}</span>
  </ng-template>
                            </ng-select>
                            <small class="form-text text-muted danger" *ngIf="
                                !course.valid && (course.dirty || course.touched)
                              ">course is required!</small>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="batch">Batch</label>
                            <ng-select [items]="batchList" bindLabel="name" bindValue="_id"
                            placeholder="Select Batch" [(ngModel)]="selectedBatch" [ngModelOptions]="{ standalone: true }"
                            (change)="getBatchId($event)">
                              <!-- <ng-template ng-header-tmp>
                                <div>
                                  <button class="btn btn-link" (click)="openContent(2)">
                                    Add New Batch
                                  </button>
                                </div>
                              </ng-template> -->
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="batch">Batch Schedule</label>
                            <ng-select [items]="batchList" bindLabel="displayname" bindValue="_id"
                            placeholder="Select Batch Schedule" [(ngModel)]="batchSchedule_list" [ngModelOptions]="{ standalone: true }"
                            (change)="getBatchScheduleId($event)">
                              <!-- <ng-template ng-header-tmp>
                                <div>
                                  <button class="btn btn-link" (click)="openContent(2)">
                                    Add New Batch
                                  </button>
                                </div>
                              </ng-template> -->
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="notes">Total Fees</label>
                            <input class="form-control input-md" [(ngModel)]="enrolmentModel.total_fees" ngModel
                              #TotalFee="ngModel" required id="TotalFee" name="TotalFee" type="text" />
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="notes">Net Fees</label>
                            <input class="form-control input-md" [(ngModel)]="enrolmentModel.net_fees" ngModel
                              #NetFee="ngModel" required id="NetFee" name="NetFee" type="text" />
                            <!-- <div class="form-group">
                              <label class="form-control-label" for="goal">Goal</label>
                              <ng-select [items]="goalList" bindLabel="displayname" bindValue="_id"
                                [closeOnSelect]="false" placeholder="Select Goal" [(ngModel)]="goal"
                                [ngModelOptions]="{ standalone: true }">
                              </ng-select>
                            </div> -->
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="discount">Discount</label>
                            <ng-select [items]="discountList" bindLabel="name" bindValue="_id" [multiple]="true"
                              placeholder="Select Discount" [(ngModel)]="selectedDiscount"
                              [ngModelOptions]="{ standalone: true }" (change)="getDiscountId($event)">
                            </ng-select>
                          </div>
                          <!-- <div class="form-group">
                            <label class="form-control-label" for="discount_amounts">Paying Amount</label>
                            <input type="number" class="form-control input-md" [(ngModel)]="paid_amount" ngModel
                              #payable_amount="ngModel" name="payable_amount" />
                          </div>  -->
                          <!-- <div class="form-group">
                            <label class="form-control-label" for="discount_amounts"
                              >Paying Amount</label
                            >
                            <input
                              type="number"
                              class="form-control input-md"
                              [(ngModel)]="paid_amount"
                              ngModel
                              #payable_amount="ngModel"
                              name="payable_amount"
                            />
                            <small
                              class="form-text text-muted danger"
                              *ngIf="
                                !payable_amount.valid &&
                                (payable_amount.dirty || payable_amount.touched)
                              "
                              >payable amount is required!</small
                            >
                          </div> -->
                        
                          <div class="form-group">
                            <label class="form-control-label" for="next_payment_date">Next Payment Date</label>
                            <input type="date" class="form-control input-md"  [(ngModel)]="enrolmentModel.next_payment_date" ngModel
                              #next_payment_date="ngModel" name="next_payment_date">
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="date_of_joining">Date Of Joining</label>
                            <input type="date" class="form-control input-md"  [(ngModel)]="enrolmentModel.date_of_joining"   ngModel
                              #date_of_joining="ngModel" name="date_of_joining"
                              [ngModel]="enrolmentModel.date_of_joining | date: 'yyyy-MM-dd'">
                          </div>
                          
                          <div class="form-group">
                            <label class="form-control-label" for="status">Payment Status</label>
                            <ng-select [items]="pamentStatusList" bindLabel="label" bindValue="name"
                              placeholder="Select Status" [(ngModel)]="selectedPaymentStatus"
                              [ngModelOptions]="{ standalone: true }">
                            </ng-select>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="notes">Documents Submitted</label>
                            <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.notes" ngModel
                              #notes="ngModel" name="notes" id="notes" cols="30" rows="2"></textarea>
                            <small class="form-text text-muted danger"
                              *ngIf="!notes.valid && (notes.dirty || notes.touched)">notes is required!</small>
                          </div>
                          <div class="form-group">
                            <label class="form-control-label" for="admin_notes">Payment Description</label>
                            <textarea class="form-control input-md" [(ngModel)]="enrolmentModel.admin_notes" ngModel
                              #admin_notes="ngModel" name="admin_notes" id="admin_notes" cols="30" rows="2"></textarea>
                          </div>
                        </div>

                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2">
                          <button type="submit" class="btn btn-primary mb-2 mb-sm-0 mr-sm-2" (click)="submit()">Save
                            Changes</button>
                          <button type="reset" class="btn btn-secondary" (click)="back()">Cancel</button>
                        </div>
                      </div>
                    </form>
                    <!-- Account form ends -->
                  </div>
                  <!-- Account content ends -->
                </ng-template>
              </li>
            </ul>
            <div class="tab-content">
              <div [ngbNavOutlet]="nav"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!---------------------------------------------------------------------------------------------------------- -->
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>